import React, { useState } from "react";
import { Form, Card, Button } from "react-bootstrap";
import validator from "validator";
import Bar from '../Bar';

// creating functional component ans getting props from app.js and destucturing them
const StepTwo = ({ nextStep, handleFormData, prevStep, values }) => {
  const [reasult, setResult] = useState("");

  const [FirstInput, setFirstInput] = useState("");


  const handelFirstInput = (val1) => {
    setFirstInput(val1.target.value);
  };


  const handeloperation = (op) => {
    const p1 = parseInt(FirstInput);
    const p2 = 1.07;
    const p3 = 1.15;
    const p4 = 1.01;
    const p5 = 1.30;
    const p6 = 1.17;
    switch (op) {
      case "low":
        if (Number.isNaN(p1 * p2)) {
          setResult("please enter only numbers");
        } else {
          setResult(p1 * p2);
        }
        break;

      case "psychological":
        if (Number.isNaN(p1 * p3 - 0.1)) {
          setResult("please enter only numbers");
        } else {
          setResult(p1 * p3 - 0.1);
        }
        break;

      case "penetration":
        if (Number.isNaN(p1 * p4)) {
          setResult("please enter only numbers");
        } else {
          setResult(p1 * p4);
        }
        break;

      case "scrape":
        if (Number.isNaN(p1 * p5)) {
          setResult("please enter only numbers");
        } else {
          setResult(p1 * p5);
        }

        break;
      case "regular":
        if (Number.isNaN(p1 * p6)) {
          setResult("please enter only numbers");
        } else {
          setResult(p1 * p6);
        }

        break;
    }
  };
 
  //creating error state for validation
  const [error, setError] = useState(false);

    // after form submit validating the form data using validator
  const submitFormData = (e) => {
    e.preventDefault();

     // checking if value of first name and last name is empty show error else take to next step
    if (validator.isEmpty(values.fixedcostsvalue)) {
      setError(true);
    } else {
      nextStep();
    }
  };
  return (
    <>
    <Bar/>
      <Card style={{ marginTop: 100 }}>
        <Card.Body>
          <Form onSubmit={submitFormData}>
            <Form.Group className="mb-3">
            <p className="fw-bold h5">Low Pricing</p>
            This strategy is used by many companies, including food suppliers and retailers, in order to attract more customers as it involves reducing production and marketing costs in order to lower the price of the product. While this type of pricing is very effective for large companies, as they replace low price with large production, it can be dangerous for small companies that do not have as large a turnover as large companies, and do their best to make enough profit at low price.
            <p className="fw-bold h5">Psychological Pricing</p>
            And acquaintances with the scientific name that bears the first name that bears the first name of the purchase. The previous example setting the price at 199 has proven to be effective in getting the price at 200 Although the difference between the two prices is very small, one explanation for this purpose makes it known as the name and conduct of a large business.
            <p className="fw-bold h5">Market Scrape</p>
            Companies that are new to the market resort to it, or to penetrate the market with a new product, which is setting a low price, which may sometimes reach a zero profit margin, in order to penetrate the market and form fulcrums through which to move towards customers, and then quickly switch to a pricing strategy other after achieving the desired results.
            <p className="fw-bold h5">Market Penetration</p>
            It consists in offering the new products at a very high price, then gradually decreasing the price as competitors' products appear in the market. This strategy is followed in the market by income classes and the elasticity of demand for the commodity. A high price is set for the new commodity so that this price is directed to the first category in the market, which is interested in obtaining the commodity, no matter how high the price. When there are few or no new sales opportunities for this category. The price is reduced so that it is suitable for the next category in the market. Thus the reduction is constantly being done to gain new categories. One of the advantages of this strategy is that it allows companies to maximize profits in the early stages, and also helps small companies create a perception of the quality of their products when they are introduced for the first time.
            <p className="fw-bold h5">Regular pricing</p>
            This strategy is characterized by its simplicity and consistency of profit from the sale. Many companies rely on this method and it is suitable for traditional projects. However, it is not suitable for entrepreneurial projects, and the reason for this is due to the constant competition in the market that may lead to the need to re-design the product or service to suit the market, which raises costs. Also, this equation does not take into account factors related to competitiveness, market value, market condition, and purchasing power.

              <Form.Label>Costs Value<optional>*</optional></Form.Label>

        <div className="firstrow">
        <input
          value={FirstInput}
          onChange={(e) => handelFirstInput(e)}
          className="input"
          placeholder="Add Number"
        />
      </div>
      <div className="btn-group btn-group-toggle" style={{  display: "flex", justifyContent: "space-around"  ,marginTop: 25 ,marginBottom: 10 }}>
        <Button variant="success"
          onClick={() => {
            handeloperation("low");
          }}
          className="bt1"
        >
          Low Pricing
        </Button>

        <Button variant="success"
          onClick={() => {
            handeloperation("psychological");
          }}
          className="bt1"
        >
          Psychological Pricing
        </Button>
        <Button variant="success"
          onClick={() => {
            handeloperation("scrape");
          }}
          className="bt1"
        >
          Market Scrape
        </Button>
        <Button variant="success"
          onClick={() => {
            handeloperation("penetration");
          }}
          className="bt1"
        >
          Market Penetration
        </Button>
        <Button variant="success"
          onClick={() => {
            handeloperation("regular");
          }}
          className="bt1"
        >
          Regular pricing
        </Button>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around"  ,marginTop: 10 ,marginBottom: 25 }}>
        <Button variant="danger"
          onClick={() => {
            setFirstInput("");
            setResult("");
          }}
          className="bt2"
        >
          CLEAR
        </Button>
      </div>
      <p className="fw-bold h4 p-3 mb-2 bg-warning text-dark"> <i className="bi bi-award"/> The Result is: {reasult}</p>

              {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}
            </Form.Group>

            <div style={{ display: "flex", justifyContent: "space-around"  ,marginTop: 25 }}>
              <Button variant="primary" onClick={prevStep}>
                Previous
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default StepTwo;
